<!--  -->
<template>
  <section class="line-step">
    <div :class="[isStep1 ? 'circle-color0' : 'circle-grey', 'circle']"></div>
    <div :class="[isStep1 ? 'line-step1' : 'line-step2']"></div>
    <div :class="[isStep1 ? 'circle-color1' : 'circle-color0', 'circle']"></div>
  </section>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {}
  },
  props: {
    isStep1: {
      type: Boolean,
      default: false
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/mixin';
.line-step {
  display: flex;
  flex-direction: column;
  align-items: center;

  .circle {
    width: rem(10px);
    height: rem(10px);
    border-radius: 100px;
    background: #fff;
  }
  .circle-grey {
    border: rem(2px) solid #b3b3b3;
  }
  .circle-color0 {
    border: rem(2px) solid #ff5900;
  }
  .circle-color1 {
    border: rem(2px) solid #ff5900;
    opacity: 0.5;
  }

  .line-step1 {
    &::before {
      display: flex;
      content: '';
      margin-inline: 1px;
      width: rem(2px);
      height: rem(20px);
      background: #ff5900;
    }
    &::after {
      display: flex;
      content: '';
      margin-inline: 1px;
      width: rem(2px);
      height: rem(20px);
      background: #ff5900;
      opacity: 0.5;
    }
  }
  .line-step2 {
    &::before {
      display: flex;
      content: '';
      margin-inline: 1px;
      width: rem(2px);
      height: rem(20px);
      background: #b3b3b3;
    }
    &::after {
      display: flex;
      content: '';
      margin-inline: 1px;
      width: rem(2px);
      height: rem(20px);
      background: #ff5900;
    }
  }
}
</style>
